module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.validate) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Register")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Role",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm2.role),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "role", $$v)
      },
      expression: "ruleForm2.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "UserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "username", $$v)
      },
      expression: "ruleForm2.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rePassword",
      "label": "Confirm Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.ruleForm2.rePassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rePassword", $$v)
      },
      expression: "ruleForm2.rePassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.laoding
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Register\n        ")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03abbdbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register.vue
// module id = 811
// module chunks = 1